"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatMana = exports.MAXIMUM_FRACTION_DIGITS = void 0;
exports.MAXIMUM_FRACTION_DIGITS = 2;
function formatMana(mana, maximumFractionDigits) {
    if (maximumFractionDigits === void 0) { maximumFractionDigits = exports.MAXIMUM_FRACTION_DIGITS; }
    return (Number(mana) / 1e18).toFixed(maximumFractionDigits).toLocaleString();
}
exports.formatMana = formatMana;
